export const MORTGAGE_REFI_1 = 'MORTGAGE_REFI_1';

export const SUPPORTED_KEY_ACTIONS = {
	[MORTGAGE_REFI_1]: {
		keyAction: MORTGAGE_REFI_1,
		title: 'Mortgage Refinance',
		description:
			'This key action monitors a refinance opportunity for clients.'
	}
};

export const DEFAULT_KEY_ACTION_RATE = 6.25;
export const DEFAULT_KEY_ACTION_DATE = '06/01/2023';
